<template>
  <nav>
    <v-app-bar dark
               app
               style="height: 80px"
               class="d-flex align-center justify-space-between px-toolbar card-shadow"
               color="white">
      <div class="full-width d-flex">
        <v-app-bar-nav-icon v-if="isSmall"
                            color="primary"
                            x-large
                            @click="toggleNavigation"/>
        <div>
          <v-img class="header-logo"
                 width="200"
                 src="../../assets/logo-proxpect.svg"
                 alt="Logo da Proxpect"/>
        </div>
      </div>
      <div class="d-flex">
        <px-notificacoes x-large btn-color="primary" icon="mdi-bell-outline"/>
        <px-user-info/>
      </div>
    </v-app-bar>

    <px-naviagtion v-model="navigationOpened"/>

  </nav>
</template>

<script>
import Navigation from '../navigation/Navigation.vue';

export default {
  data() {
    return {
      navigationOpened: false,
    };
  },
  computed: {
    isSmall() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    toggleNavigation() {
      this.navigationOpened = !this.navigationOpened;
    },
    changeNavigation(value) {
      if (this.navigationOpened !== value) {
        this.navigationOpened = value;
      }
    },
  },
  components: {
    pxNaviagtion: Navigation,
  },
};
</script>
